(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["3dorder-purchase-clarity"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('do-purchase-clarity')) {
    customElements.define('do-purchase-clarity', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const section = this.closest('.shopify-section, dialog');
        section?.addEventListener('variant:update', (event) => {
          if (String(event.detail?.data?.productId) !== this.dataset.productId) return;
          const incoming = event.detail?.data?.html?.querySelector('do-purchase-clarity');
          if (!incoming) return;
          this.innerHTML = incoming.innerHTML;
          this.setAttribute('aria-label', incoming.getAttribute('aria-label') || '');
        }, { signal: this.controller.signal });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
